import { TourConfig, TourType } from "@/contexts/TourContext";

export const TOUR_CONFIGS: Record<TourType, TourConfig> = {
  "create-circle": {
    id: "create-circle",
    name: "Create Circle Tour",
    totalSteps: 7,
    storageKey: "create-circle-tour-state",
    description: "Learn how to create a new circle from start to finish",
  },
  "circles-page": {
    id: "circles-page",
    name: "Circles Page Tour",
    totalSteps: 4,
    storageKey: "circles-page-tour-state",
    description: "Explore the Circles page and its features",
  },
};
